export const getMediaBaseUrl = () => {
  const host = window.location.host.toLowerCase().split('.')[0];

  if (['www', 'gripp'].includes(host)) {
    return 'https://media.gripp.it';
  } else {
    return 'https://media.nonprod.gripp.it';
  }
};
